import React from 'react'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import HallImagesTable from './Components/HallImagesTable';

const HallImagesList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Hall Images List</HeadingOne>
                    <AddItemBtn url="add-hall-images" title="Add Hall Images" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <HallImagesTable />
            </div>
        </PageBody>
    );
};

export default HallImagesList;
